import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgBookmarkLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M18 5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v14.276l5.504-3.144.118-.058a1 1 0 0 1 .874.058L18 19.276zm2 16a1 1 0 0 1-1.496.868L12 18.151l-6.504 3.717A1 1 0 0 1 4 21V5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgBookmarkLine)
export default ForwardRef
